import zh_tw from './zh-TW.json';

// 只 eager 載入預設語言 zh-TW (zh-CHT 為別名);en 由 src/i18n/index.js 動態載入
export default {
	'zh-TW': zh_tw,
	'zh-CHT': zh_tw,
};
